<template>
  <div class="card shadow">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-6">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'recipes' }">Recipes</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Edit Recipe
              </li>
            </ol>
          </nav>
        </div>
        <div class="col-6 text-right" v-if="!loading">
          <el-button v-if="recipe.status === 'A'" type="primary" size="mini" plain @click="pushView">
            View
          </el-button>
        </div>
      </div>
    </div>
    <div class="card-body" v-loading="loading">
      <el-tabs v-model="activePane" @tab-click="onTabChange">
        <el-tab-pane label="Details" name="details">
          <recipe-item-detail v-if="!loading" :recipe="recipe"/>
        </el-tab-pane>
        <el-tab-pane label="Images" name="images">
          <recipe-item-image v-if="!loading" :recipe="recipe" @update="getRecipe"/>
        </el-tab-pane>
        <el-tab-pane label="Steps" name="steps">
          <recipe-item-step v-if="!loading" :recipeId="recipe.id" :youtubeId="recipe.youtube.video_id" :recipeSteps="recipe.steps" :legacyIngredients="recipe.ingredients || []"/>
        </el-tab-pane>
        <el-tab-pane label="Associated Recipes" name="related">
          <recipe-item-association v-if="!loading" :recipeId="recipe.id" :recipeAssociations="recipe.recipes"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import RecipeItemDetail from '@/components/Recipe/Item/RecipeItemDetail'
import RecipeItemImage from '@/components/Recipe/Item/RecipeItemImage'
import RecipeItemStep from '@/components/Recipe/Item/RecipeItemStep'
import RecipeItemAssociation from '@/components/Recipe/Item/RecipeItemAssociation'

export default {
  data() {
    return {
      loading: true,
      activePane: 'details',
      recipe: {},
    }
  },

  mounted() {
    this.getRecipe()
  },

  components: {
    RecipeItemDetail,
    RecipeItemImage,
    RecipeItemStep,
    RecipeItemAssociation,
  },

  methods: {
    onTabChange(tab, event) {
      this.activePane = tab.name
    },

    async getRecipe() {
      this.loading = true
      try {
        var { data } = await this.$http.get(`/recipes/${ this.$route.params.id }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }
      this.recipe = data.recipe
    },

    pushView() {
      window.open(`${ process.env.VUE_APP_APP_HOST }/recipes/${ this.recipe.slug }~${ this.recipe.id }`)
    },
  },
}
</script>
